import { theme } from '@chakra-ui/core';

const fallbackFonts = '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';
export const fonts = {
    body: `'Inter',${fallbackFonts}`,
    button: `'Inter',${fallbackFonts}`,
    heading: `'Calibre',${fallbackFonts}`,
    hero: `'Calibre',${fallbackFonts}`,
    code: 'Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace',
    label: `'Inter',${fallbackFonts}`
};

export const fontSizes: any = {
    ...theme.fontSizes,
    '2xs': '0.625rem'
};

export const fontWeights = {
    extraLight: 100,
    light: 200,
    book: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    black: 800,
    extraBlack: 900
};

export const lineHeights: any = theme.lineHeights;

const bodyStyle = {
    fontFamily: 'body',
    fontWeight: 'regular'
};

const headingStyle = {
    fontFamily: 'heading',
    fontWeight: 'bold'
};

export const textStyles: any = {
    body: {
        ...bodyStyle,
        fontSize: ['md', null, null, 'lg']
    },
    callout: {
        ...bodyStyle,
        fontSize: ['sm', null, null, 'md']
    },
    caption1: {
        ...bodyStyle,
        fontSize: 'sm'
    },
    caption2: {
        ...bodyStyle,
        fontSize: 'xs'
    },
    footnote: {
        ...bodyStyle,
        fontSize: '2xs'
    },
    largeHero: {
        ...headingStyle,
        fontSize: ['5xl', null, null, '6xl']
    },
    hero: {
        ...headingStyle,
        fontSize: ['4xl', null, null, '5xl']
    },
    headline: {
        ...headingStyle,
        fontSize: ['3xl', null, null, '4xl']
    },
    subheadline: {
        ...headingStyle,
        fontSize: ['2xl', null, null, '3xl']
    },
    title1: {
        ...headingStyle,
        fontSize: ['xl', null, null, '2xl']
    },
    title2: {
        ...headingStyle,
        fontSize: ['lg', null, null, 'xl']
    },
    title3: {
        ...headingStyle,
        fontSize: ['md', null, null, 'lg']
    },
    label: {
        fontFamily: 'label',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        letterSpacing: 'widest',
        lineHeight: 'none'
    },
    value: {
        fontFamily: 'heading',
        fontWeight: 'semibold',
        fontSize: 'xl',
        letterSpacing: 'wide',
        lineHeight: 'none'
    },
    code: {
        fontFamily: 'code',
        fontWeight: 'normal',
        fontSize: ['md', null, null, 'lg']
    }
};

export const letterSpacings: any = {
    ...theme.letterSpacings,
    tightest: '-0.1em',
    '2widest': '0.2em'
};
